module.exports = __webpack_public_path__ + "static/media/accesorios.769890c8.png";